import React, { useEffect, useRef } from "react";

// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";

import styles from "./leaderboard.module.scss";
import "swiper/css";

// import { capitalize } from "lodash";

// import ExpandArrowIcon from "@/assets/icons-v2/expand_arrow.png";
import CustomTabPanel from "@/components/common/CustomTabPanel";
/** @deprecated Classic leaderboard tab retired; component kept on disk */
// import Classic from "./components/Classic";
import Puzzle from "./components/Puzzle";

import { LIVE_VARIANT_VERSIONS } from "@/constants/live-variant-versions";

import { useUser } from "@/context/UserContext";
import useMixpanelEvent from "@/hooks/useMixpanelEvent";
import useLocalStorage from "@/hooks/useLocalStorage";
import AdSenseAd from "@/components/common/AdSenseAd/AdSenseAd";

type LiveVariantVersion = (typeof LIVE_VARIANT_VERSIONS)[keyof typeof LIVE_VARIANT_VERSIONS];

const versions = Object.values(LIVE_VARIANT_VERSIONS) as LiveVariantVersion[];
const PUZZLE_TAB_INDEX = versions.findIndex((v) => v.url === "puzzle");

/*
const isDisabledInLeaderboard = (version: LiveVariantVersion): boolean =>
    "disableInProfile" in version && Boolean(version.disableInProfile);
*/
/** @deprecated Classic tab index retained for reference if tab is re-enabled */
// const CLASSIC_TAB_INDEX = versions.findIndex((v) => v.url === "classic");

const Leaderboard: React.FC = () => {
    const { userState, setUserState } = useUser();
    const { sendEvent: sendMixpanelEvent } = useMixpanelEvent();
    const [visitorStatus] = useLocalStorage("visitor-status", "");
    const lastTrackedRef = useRef<string | null>(null);
    /*
    let selectedVersion = (userState?.leaderboardSelectedVersion as string) || "classic";
    let tabValue = versions.findIndex((v: any) => v.url === selectedVersion);
    if (tabValue === -1) {
        const puzzleTabIndex = versions.findIndex((v: any) => v.url === "puzzle");
        const classicTabIndex = versions.findIndex((v: any) => v.url === "classic");
        tabValue = selectedVersion === "puzzle" && puzzleTabIndex !== -1 ? puzzleTabIndex : classicTabIndex;
    }
    */
    // const storedVersion = (userState?.leaderboardSelectedVersion as string) || "puzzle";
    // const selectedVersion = storedVersion === "classic" ? "puzzle" : storedVersion;
    // let tabValue = versions.findIndex((v) => v.url === selectedVersion);
    // if (tabValue === -1) {
    //     tabValue = PUZZLE_TAB_INDEX !== -1 ? PUZZLE_TAB_INDEX : 0;
    // }
    const selectedVersion = "puzzle";
    const tabValue = PUZZLE_TAB_INDEX !== -1 ? PUZZLE_TAB_INDEX : 0;

    useEffect(() => {
        const stored = localStorage.getItem("leaderboardSelectedVersion");
        if (stored) {
            const normalizedVersion = stored === "classic" ? "puzzle" : stored;
            setUserState({ ...userState, leaderboardSelectedVersion: normalizedVersion });
            localStorage.removeItem("leaderboardSelectedVersion");
        }
    }, [setUserState, userState]);

    useEffect(() => {
        const path = window.location.pathname;
        if (path !== "/leaderboard") return;
        if (lastTrackedRef.current === path) return;
        const key = `page_view_tracked:${path}`;
        const now = Date.now();
        const lastTsRaw = sessionStorage.getItem(key);
        const lastTs = lastTsRaw ? Number(lastTsRaw) : 0;
        const FIVE_MIN_MS = 5 * 60 * 1000;
        if (now - lastTs < FIVE_MIN_MS) return;

        /*
        const mixpanelVersion =
            userState?.leaderboardSelectedVersion || localStorage.getItem("leaderboardSelectedVersion") || "puzzle";
        const versionLabel = mixpanelVersion === "classic" ? "Classic" : "Puzzle";
        */

        sendMixpanelEvent("Page View", {
            isAuthenticated: !!userState?.id,
            visitorStatus: userState?.id ? null : visitorStatus || "new-guest",
            pageName: "Leaderboard - Puzzle",
            // pageName: `Leaderboard - ${versionLabel}`,
            user_id: userState?.id || null,
            nickname: userState?.nickname || null,
            email: userState?.emailAddress || null,
            pageUrl: window.location.href,
        });

        lastTrackedRef.current = path;
        sessionStorage.setItem(key, String(now));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /*
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDropdown = (event: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget as HTMLElement);
    };

    const handleSelect = (_event: unknown, newTabValue: number) => {
        setUserState({ ...userState, leaderboardSelectedVersion: versions[newTabValue].url });
        setAnchorEl(null);
    };
    */

    return (
        <div className={styles.container + " !tw-px-4"}>
            <div className="tw-flex tw-gap-1 tw-mb-[-10px]">
                <h3 className="leaderboard-title">Leaderboard:</h3>
                <h3 className="leaderboard-title">Puzzle</h3>
                {/*
                <div
                    className="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-cursor-pointer"
                    onClick={handleDropdown}
                >
                    <h3 className="leaderboard-title">{capitalize(versions[tabValue]?.label ?? "puzzle")}</h3>
                    <img className="tw-mb-[.5em]" src={ExpandArrowIcon} alt="expand-arrow-icon" />
                </div>

                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        "aria-labelledby": "basic-button",
                    }}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    sx={{ mt: -1 }}
                >
                    {versions.map((version, index) => {
                        const isDisabled = isDisabledInLeaderboard(version);
                        const versionLabel = capitalize(version.label);
                        return (
                            <MenuItem
                                key={version.url}
                                onClick={(e) => handleSelect(e, index)}
                                selected={tabValue === index}
                                disabled={isDisabled}
                            >
                                {isDisabled ? `${versionLabel} (Coming soon)` : versionLabel}
                            </MenuItem>
                        );
                    })}
                </Menu>
                */}
            </div>

            {/*
            <CustomTabPanel value={tabValue} index={(versions as any).findIndex((v: any) => v.url === "classic")}>
                <Classic />
            </CustomTabPanel>
            <CustomTabPanel value={tabValue} index={(versions as any).findIndex((v: any) => v.url === "puzzle")}>
                <Puzzle version={(versions as any)[tabValue]} />
            </CustomTabPanel>
            */}
            <CustomTabPanel value={tabValue} index={PUZZLE_TAB_INDEX}>
                <Puzzle version={selectedVersion} />
            </CustomTabPanel>
            <AdSenseAd />
        </div>
    );
};

export default Leaderboard;
